import React from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./Offer.module.sass";

const AppelAction = ({ className }) => {
  return (
    <div className={cn("section-bg", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={cn("stage", styles.stage)}>
          Démo gratuite disponible 🚀
        </div>
        <h2 className={cn("h1", styles.title)}>
          Commencez dès aujourd'hui
        </h2>
        <div className={styles.text}>
          Découvrez comment notre solution peut transformer la gestion de votre CFA. Démo gratuite et accompagnement personnalisé inclus.
        </div>
        <Link className={cn("button", styles.button)} to="/contact">
          Demander une démo gratuite
        </Link>
      </div>
    </div>

  );
};

export default AppelAction;
